// extracted by mini-css-extract-plugin
export var navbarDividedLeft = "K_fQ d_fQ d_bz d_bH d_bJ";
export var navbarDividedRight = "K_fR d_fR d_bz d_bJ";
export var menuDesign6 = "K_wg d_fM d_bz d_dw d_bP d_bJ";
export var menuDesign7 = "K_wh d_fM d_bz d_dw d_bP d_bJ";
export var menuRight = "K_wj d_fM d_bz d_dw d_bP d_bJ";
export var menuLeft = "K_wk d_fM d_bz d_dw d_bP d_bJ";
export var menuCenter = "K_wl d_fN d_fM d_bz d_dw d_bP d_w d_bD d_bJ";
export var menuDivided = "K_m9 d_fN d_fM d_bz d_dw d_bP d_w d_bD";
export var menuDesign5 = "K_nl d_fP d_fM d_bz d_dw d_bP d_bJ";
export var isBurger = "K_wm";
export var navbarItem = "K_nb d_bx";
export var navbarLogoItemWrapper = "K_fY d_fY d_bC d_bP";
export var burgerToggleVisibleOpen = "K_wn d_gd d_by d_Z d_bs";
export var burgerToggleVisible = "K_wp d_gd d_by d_Z d_bs";
export var burgerToggle = "K_wq d_gd d_by d_Z d_bs d_Z";
export var burgerToggleOpen = "K_wr d_gd d_by d_Z d_bs";
export var burgerInput = "K_ws d_f2 d_w d_H d_by d_cc d_dl d_bd d_0 d_8 d_7 d_4 d_9";
export var burgerIcon = "K_wt d_f3 d_w d_H";
export var burgerLine = "K_wv d_f1";
export var burgerMenuDesign6 = "K_ww d_f7 d_f6 d_f4 d_f5 d_0 d_cc d_dm d_bs d_dw";
export var burgerMenuDesign7 = "K_wx d_f7 d_f6 d_f4 d_f5 d_0 d_cc d_dm d_bs d_dw";
export var burgerMenuLeft = "K_wy d_f7 d_f6 d_f4 d_f5 d_0 d_cc d_dm d_bs d_dw d_f7 d_f6 d_f4 d_f5 d_0 d_cc d_dm d_bs d_dw";
export var burgerMenuDesign5 = "K_wz d_f8 d_f6 d_f4 d_f5 d_0 d_cc d_dm d_bs d_dw";
export var burgerMenuRight = "K_wB d_f8 d_f6 d_f4 d_f5 d_0 d_cc d_dm d_bs d_dw";
export var burgerMenuCenter = "K_wC d_f9 d_f6 d_f4 d_f5 d_0 d_cc d_dm d_bs d_dw";
export var burgerMenuDivided = "K_wD d_f7 d_f6 d_f4 d_f5 d_0 d_cc d_dm d_bs d_dw";
export var secondary = "K_wF d_bC d_bP";
export var compact = "K_wG";
export var navDivided = "K_wH";
export var staticBurger = "K_wJ";
export var menu = "K_wK";
export var navbarDividedLogo = "K_wL";
export var nav = "K_wM";
export var fixed = "K_wN";